import React from 'react'
import { Navigate } from 'react-router-dom'
import BankAccountDetail from './BankAccounts/BankAccountDetail'
import BankAccounts from './BankAccounts/BankAccounts'
import ChartOfAccounts from './ChartOfAccounts/ChartOfAccounts'
import CostCenters from './costCenters/CostCenters'
import Dashboard from './dashboard/Dashboard'
import DemoBatchDetail from './demoData/DemoBatchDetail'
import DemoData from './demoData/DemoData'
import Expenses from './expenses/Expenses'
import InvoiceDetail from './invoices/InvoiceDetail'
import Invoices from './invoices/Invoices'
import Journal from './Journal/Journal'
import JournalEntries from './JournalEntries/JournalEntries'
import Partners from './partners/Partners'
import PaymentDetail from './payments/PaymentDetail'
import Payments from './payments/Payments'
import Periods from './periods/Periods'
import ReconciliationPage from './reconciliation/Reconciliation'
import ReconciliationDetail from './reconciliation/ReconciliationDetail'
import AccountBalances from './reports/AccountBalances'
import CashFlow from './reports/CashFlow'
import ExpenseRegister from './reports/ExpenseRegister'
import GeneralLedger from './reports/GeneralLedger'
import InvoiceRegister from './reports/InvoiceRegister'
import PartnerBalances from './reports/PartnerBalances'
import PayableAging from './reports/PayableAging'
import PaymentRegister from './reports/PaymentRegister'
import ReceivableAging from './reports/ReceivableAging'
import Reports from './reports/Reports'
import TopBalances from './reports/TopBalances'
import TrialBalance from './reports/TrialBalance'
import Settings from './settings/Settings'
import VendorBillDetail from './vendorBills/VendorBillDetail'
import VendorBills from './vendorBills/VendorBills'

export const ROUTES = [
  {
    component: Dashboard,
    isModuleRequired: true,
    path: '/finance',
    slug: 'accounts',
    title: 'accounts',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: ChartOfAccounts,
    isModuleRequired: true,
    path: '/finance/accounts',
    slug: 'accounts',
    title: 'accounts',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
  },
  {
    component: Journal,
    isModuleRequired: true,
    path: '/finance/journals',
    slug: 'accounts',
    title: 'accounts',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
  },
  {
    component: JournalEntries,
    isModuleRequired: true,
    path: '/finance/journal-entries',
    slug: 'accounts',
    title: 'accounts',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
  },
  {
    component: Periods,
    isProtected: true,
    showMenu: true,
    path: '/finance/periods',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Partners,
    isProtected: true,
    showMenu: true,
    path: '/finance/partners',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: CostCenters,
    isProtected: true,
    showMenu: true,
    path: '/finance/cost-centers',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Expenses,
    isProtected: true,
    showMenu: true,
    path: '/finance/expenses',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Reports,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: TrialBalance,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/trial-balance',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: GeneralLedger,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/general-ledger',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: AccountBalances,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/account-balances',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: ExpenseRegister,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/expense-register',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: CashFlow,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/cash-flow',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: TopBalances,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/top-balances',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: InvoiceRegister,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/invoice-register',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: PaymentRegister,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/payment-register',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: PartnerBalances,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/partner-balances',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: ReceivableAging,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/receivable-aging',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: PayableAging,
    isProtected: true,
    showMenu: true,
    path: '/finance/reports/payable-aging',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Invoices,
    isProtected: true,
    showMenu: true,
    path: '/finance/invoices',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: InvoiceDetail,
    isProtected: true,
    showMenu: false,
    path: '/finance/invoices/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: VendorBills,
    isProtected: true,
    showMenu: true,
    path: '/finance/vendor-bills',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: VendorBillDetail,
    isProtected: true,
    showMenu: false,
    path: '/finance/vendor-bills/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Payments,
    isProtected: true,
    showMenu: true,
    path: '/finance/payments',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: PaymentDetail,
    isProtected: true,
    showMenu: false,
    path: '/finance/payments/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: ReconciliationPage,
    isProtected: true,
    showMenu: true,
    path: '/finance/reconciliation',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: ReconciliationDetail,
    isProtected: true,
    showMenu: false,
    path: '/finance/reconciliation/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: DemoData,
    isProtected: true,
    showMenu: true,
    path: '/finance/demo-data',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: DemoBatchDetail,
    isProtected: true,
    showMenu: false,
    path: '/finance/demo-data/batches/:batchId',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: Settings,
    isProtected: true,
    showMenu: true,
    path: '/finance/settings',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: () => <Navigate to="/finance/journals" replace />,
    isProtected: true,
    showMenu: false,
    path: '/finance/journal',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: () => <Navigate to="/finance/settings/bank-accounts" replace />,
    isProtected: true,
    showMenu: false,
    path: '/accounts/bank-accounts',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: () => <Navigate to="/finance/settings/bank-accounts" replace />,
    isProtected: true,
    showMenu: false,
    path: '/accounts/bank-accounts/details/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: BankAccounts,
    isProtected: true,
    showMenu: true,
    path: '/finance/settings/bank-accounts',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
  {
    component: BankAccountDetail,
    isProtected: true,
    showMenu: true,
    path: '/finance/settings/bank-accounts/:id',
    slug: 'accounts',
    title: 'accounts',
    redirectTo: '/auth/login',
  },
]
